<div class="logo-container">
    <a class="logo img pt-3 logocon">
      <div class="coname">{{ companyName }}</div>
      <div class="cogroup">{{ companyGroup }}</div>
    </a>

    <div class="pl-4 projdesc">
      <div class="head-desc">{{ headerTitle }}</div>
      <div class="subhead-desc">{{ subHeaderTitle }}</div>
      <div class="vendor-subhead">
        <!-- <div class="vendor-subhead-title">PPPP</div> -->
         
      </div>
    </div>
  </div>
  


      <!-- User Profile Menu Component -->
  <!-- <div class="header-profile-container">
    <app-user-profile-menu-component></app-user-profile-menu-component>
  </div> -->
  <div class="header-quick-controls">
    <div class="header-profile-container">
      <app-user-profile-menu-component></app-user-profile-menu-component>
    </div>
    <!-- Role Selector (replicated from applicant layout) -->
    <div class="control-item role-selector">
      <select class="form-select form-select-sm header-select" [(ngModel)]="selectedRole" (change)="onRoleChange()" title="Select your role">
        <option *ngFor="let r of availableRoles" [value]="r">{{ r }}</option>
      </select>
    </div>
    <!-- Language Selector -->
    <div class="language-selector">
      <select class="form-select form-select-sm header-select" [(ngModel)]="selectedLanguage" (change)="onLanguageChange()">
        <option value="en" style="background-color: white; color: #106ed3;">English</option>
        <option value="hi" style="background-color: white; color: #106ed3;">हिंदी</option>
      </select>
    </div>
  </div>


    <!-- =========== Notification and dropdown on small screen============= -->

    <div class="d-flex align-items-center right-align header-actions"  style="cursor: pointer; position: absolute; right: 10px; margin-top: -42px">
      <button nbButton ghost size="small" class="header-icon-btn mr-3" nbTooltip="Toggle sidebar" nbTooltipPlacement="bottom" (click)="toggleMenuSidebar()">
        <nb-icon icon="menu-2-outline"></nb-icon>
      </button>
  
      <div (click)="toggleDropdown()" class="menu-toggle" style="cursor: pointer;">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-width="2" d="M4 6h16M4 12h16m-7 6h7" />
        </svg>
      </div>
    </div>
  <!-- Language Dropdown -->

<!-- {{filteredMenu | json}} -->
    
    <div *ngIf="dropdownOpen" class="dropdown-menu ">
      <nb-menu [items]="filteredMenu" (click)="toggleDropdown()"></nb-menu>
    </div>
    